import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Framework from '@/views/Framework/Index.vue'
import Layout from '@/views/Layout/Index.vue'
import Login from '@/views/Login/Index.vue'
import Book from '@/views/Book/Book.vue'
import CourseBook from '@/views/PHDCourse/CourseBook.vue'
import FlashCard from '@/views/PHDCourse/FlashCard.vue'
import NotFound from '@/views/404/Index.vue'
import Store from '@/store/index'
import { ssoUtils } from 'sso-utils'

import {
  getToken,
  getSchoolInfo,
  removeToken,
  getRoleType,
  removeSchoolInfo,
  setToken,
  setSchoolInfo,
  setRoleType,
} from '@/utils/utils'
import { FeatureController, LoginController, SchoolController } from '@/services/request.service'

Vue.use(VueRouter)

export const home = {
  path: 'home',
  name: 'home',
  component: Framework,
  meta: {
    routerName: 'home',
    auth: ['1401', '1402', '1403', '1404'],
    rootPage: true,
    menu: true,
  },
}

export const moment = {
  path: 'moment',
  component: Framework,
  meta: {
    routerName: 'moment',
    auth: ['1401', '1402', '1403', '1404', '1405'],
    rootPage: true,
    noChild: true,
    menu: true,
  },
  children: [
    {
      path: '',
      name: 'moment',
      component: Framework,
      meta: {
        routerName: 'moment',
        rootPage: true,
      },
    },
    {
      path: 'send',
      name: 'sendMoment',
      component: Framework,
      meta: {
        routerName: 'sendMoment',
      },
    },
    {
      path: 'batchSend',
      name: 'batchSendMoment',
      component: Framework,
      meta: {
        routerName: 'batchSendMoment',
      },
    },
    {
      path: 'detail/:traceId',
      name: 'momentDetail',
      component: Framework,
      meta: {
        routerName: 'momentDetail',
      },
    },
  ],
}

export const assessment = {
  path: 'assessment',
  name: 'assessment',
  component: Framework,
  redirect: {
    name: 'assessmentSheet',
  },
  meta: {
    routerName: 'assessment',
    auth: ['1401', '1402', '1403', '1404', '1405'],
  },
  children: [],
}
// 评估表
const assessmentSheet = {
  path: 'assessmentSheet',
  name: 'assessmentSheet',
  component: Framework,
  meta: {
    routerName: 'assessmentSheet',
    rootPage: true,
    noChild: true,
    menu: true,
  },
  children: [
    {
      path: 'studentAssessment',
      name: 'studentAssessment',
      component: Framework,
      meta: {
        routerName: 'studentAssessment',
        showBack: true,
      },
    },
  ],
}
// 评估报告
const assessmentReport = {
  path: 'assessmentReport',
  name: 'assessmentReport',
  component: Framework,
  meta: {
    routerName: 'assessmentReport',
    rootPage: true,
    noChild: true,
    menu: true,
  },
  children: [
    {
      path: 'editReport/:gradeReportId',
      name: 'editReport',
      component: Framework,
      meta: {
        routerName: 'editReport',
        showBack: true,
      },
    },
    {
      path: 'editRecord/:schoolYearId/:classId/:gradePeriodId',
      name: 'editRecord',
      component: Framework,
      meta: {
        routerName: 'editRecord',
        showBack: true,
      },
      children: [
        {
          path: 'editDetail/:changeId',
          name: 'editDetail',
          component: Framework,
          meta: {
            routerName: 'editDetail',
            showBack: true,
          },
        },
      ],
    },
  ],
}

export const application = {
  path: 'application',
  name: 'application',
  component: Framework,
  redirect: {
    name: 'home',
  },
  meta: {
    routerName: 'application',
  },
  children: [],
}

const attendance = {
  path: 'attendanceMgmt',
  name: 'attendanceMgmt',
  component: Framework,
  redirect: {
    name: 'classAttendance',
  },
  meta: {
    routerName: 'attendanceMgmt',
    auth: ['1401', '1402', '1403', '1404', '1405'],
    menu: true,
  },
  children: [
    {
      path: 'attendanceOverview',
      name: 'attendanceOverview',
      component: Framework,
      meta: {
        routerName: 'attendanceOverview',
        rootPage: true,
        auth: ['1401', '1402', '1403', '1404'],
      },
    },
    {
      path: 'classAttendance',
      name: 'classAttendance',
      component: Framework,
      meta: {
        routerName: 'classAttendance',
        rootPage: true,
      },
      children: [
        {
          path: 'studentAttendance',
          name: 'studentAttendance',
          component: Framework,
          meta: {
            routerName: 'studentAttendance',
            showBack: true,
          },
        },
      ],
    },
    {
      path: 'attendanceStat',
      name: 'attendanceStat',
      component: Framework,
      meta: {
        routerName: 'attendanceStat',
        rootPage: true,
      },
    },
  ],
}

const dailyCare = {
  path: 'dailyCare',
  name: 'dailyCare',
  component: Framework,
  meta: {
    routerName: 'dailyCare',
    auth: ['1401', '1402', '1403', '1404', '1405'],
    rootPage: true,
    noChild: true,
    menu: true,
  },
  children: [
    {
      path: 'studentDailyCare/:classId/:studentId/:date',
      name: 'studentDailyCare',
      component: Framework,
      meta: {
        routerName: 'studentDailyCare',
        showBack: true,
      },
    },
  ],
}

const diary = {
  path: 'diary',
  name: 'diary',
  component: Framework,
  meta: {
    routerName: 'diary',
    rootPage: true,
    noChild: true,
    menu: true,
  },
  children: [
    {
      path: 'studentDiary/:studentId',
      name: 'studentDiary',
      component: Framework,
      meta: {
        routerName: 'studentDiary',
        showBack: true,
      },
    },
    {
      path: 'addDiary',
      name: 'addDiary',
      component: Framework,
      meta: {
        routerName: 'addDiary',
        showBack: true,
      },
    },
    {
      path: 'editDiary/:diaryEntryId',
      name: 'editDiary',
      component: Framework,
      meta: {
        routerName: 'editDiary',
        showBack: true,
      },
    },
  ],
}

const album = {
  path: 'album',
  name: 'album',
  component: Framework,
  meta: {
    routerName: 'album',
    auth: ['1401', '1402', '1403', '1404', '1405'],
    rootPage: true,
    menu: true,
  },
}

const calendar = {
  path: 'calendarMgmt',
  name: 'calendarMgmt',
  component: Framework,
  meta: {
    routerName: 'calendarMgmt',
    auth: ['1401', '1402', '1403', '1404', '1405'],
    rootPage: true,
    menu: true,
  },
}

const takeLeave = {
  path: 'takeLeave',
  name: 'takeLeave',
  redirect: { name: 'takeLeavePending' },
  component: Framework,
  meta: {
    routerName: 'takeLeave',
    auth: ['1401', '1402', '1403', '1404', '1405'],
    rootPage: true,
    noChild: true,
    menu: true,
  },
  children: [
    {
      path: 'pending',
      name: 'takeLeavePending',
      component: Framework,
      meta: {
        routerName: 'takeLeavePending',
        rootPage: true,
      },
    },
    {
      path: 'audited',
      name: 'takeLeaveAudited',
      component: Framework,
      meta: {
        routerName: 'takeLeaveAudited',
        rootPage: true,
      },
    },
  ],
}

const mibp = {
  path: 'mibp',
  name: 'mibp',
  component: Framework,
  meta: {
    routerName: 'mibp',
    auth: ['1401', '1402', '1403', '1404', '1405'],
    rootPage: true,
    noChild: true,
    menu: true,
  },
}

const sketch = {
  path: 'sketch',
  name: 'sketch',
  component: Framework,
  meta: {
    routerName: 'sketch',
    auth: ['1401', '1402', '1403', '1404', '1405'],
    noChild: true,
    rootPage: true,
    menu: true,
  },
  children: [
    {
      path: 'add',
      name: 'addSketch',
      component: Framework,
      meta: {
        routerName: 'addSketch',
        showBack: true,
      },
    },
    {
      path: 'edit/:paintingId',
      name: 'editSketch',
      component: Framework,
      meta: {
        routerName: 'editSketch',
        showBack: true,
      },
    },
  ],
}

const recipe = {
  path: 'recipe',
  name: 'recipe',
  component: Framework,
  meta: {
    routerName: 'recipe',
    auth: ['1401', '1402', '1403', '1404', '1405'],
    noChild: true,
    rootPage: true,
    menu: true,
  },
  children: [
    {
      path: 'add',
      name: 'addRecipe',
      component: Framework,
      meta: {
        routerName: 'addRecipe',
        showBack: true,
      },
    },
    {
      path: 'edit/:recipeId',
      name: 'editRecipe',
      component: Framework,
      meta: {
        routerName: 'editRecipe',
        showBack: true,
      },
    },
    {
      path: 'detail/:recipeId',
      name: 'recipeDetail',
      component: Framework,
      meta: {
        routerName: 'recipeDetail',
        showBack: true,
      },
    },
  ],
}

const learningJournal = {
  path: 'learningJournal',
  component: Framework,
  meta: {
    routerName: 'learningJournal',
    auth: ['1401', '1402', '1403', '1404', '1405'],
    rootPage: true,
    showBack: true,
  },
  children: [
    {
      path: '',
      name: 'learningJournal',
      component: Framework,
      meta: {
        routerName: 'learningJournal',
        rootPage: true,
        menu: true,
      },
    },
    {
      path: 'add/:journalId',
      name: 'addLearningJournal',
      component: Framework,
      meta: {
        routerName: 'addLearningJournal',
      },
    },
    {
      path: 'edit/:journalId',
      name: 'editLearningJournal',
      component: Framework,
      meta: {
        routerName: 'editLearningJournal',
      },
    },
    {
      path: 'preview/:journalId',
      name: 'previewLearningJournal',
      component: Framework,
      meta: {
        routerName: 'previewLearningJournal',
      },
    },
  ],
}

const phdCourse = {
  path: 'phdCourse',
  name: 'phdCourse',
  component: Framework,
  meta: {
    routerName: 'phdCourse',
    auth: ['1401', '1402', '1403', '1404', '1405'],
    noChild: true,
    rootPage: true,
    menu: true,
  },
}

export const message = {
  path: 'message',
  name: 'message',
  component: Framework,
  redirect: { name: 'outbox' },
  meta: {
    routerName: 'message',
  },
  children: [
    {
      path: 'inbox',
      name: 'inbox',
      component: Framework,
      meta: {
        routerName: 'inbox',
        rootPage: true,
        noChild: true,
        menu: true,
      },
      children: [
        {
          path: 'reply/:messageId/:messageMasterId',
          name: 'replyMessage',
          hidden: true,
          component: Framework,
          meta: {
            routerName: 'replyMessage',
            showBack: true,
          },
        },
        {
          path: 'detail/:messageId',
          name: 'receivedDetail',
          hidden: true,
          component: Framework,
          meta: {
            routerName: 'receivedDetail',
            showBack: true,
          },
        },
      ],
    },
    {
      path: 'outbox',
      name: 'outbox',
      component: Framework,
      meta: {
        routerName: 'outbox',
        noChild: true,
        rootPage: true,
        menu: true,
      },
      children: [
        {
          path: 'send',
          name: 'sendMessage',
          hidden: true,
          component: Framework,
          meta: {
            routerName: 'sendMessage',
            showBack: true,
          },
        },
        {
          path: 'detail/:messageId',
          name: 'sentDetail',
          hidden: true,
          component: Framework,
          meta: {
            routerName: 'sentDetail',
            showBack: true,
          },
        },
      ],
    },
  ],
}

export const manage = {
  path: 'manage',
  name: 'manage',
  component: Framework,
  redirect: {
    name: 'classMgmt',
  },
  meta: {
    routerName: 'manage',
    auth: ['1401', '1402', '1403', '1404'],
  },
  children: [
    {
      path: 'classMgmt',
      name: 'classMgmt',
      component: Framework,
      redirect: {
        name: 'class',
      },
      meta: {
        routerName: 'classMgmt',
        menu: true,
      },
      children: [
        {
          path: 'class',
          name: 'class',
          component: Framework,
          meta: {
            routerName: 'class',
            rootPage: true,
          },
          children: [
            {
              path: 'create',
              name: 'createClass',
              component: Framework,
              meta: {
                routerName: 'createClass',
                showBack: true,
              },
            },
            {
              path: 'view/:classId',
              name: 'viewClass',
              component: Framework,
              meta: {
                routerName: 'viewClass',
                showBack: true,
              },
            },
            {
              path: 'edit/:classId',
              name: 'editClass',
              component: Framework,
              meta: {
                routerName: 'editClass',
                showBack: true,
              },
            },
          ],
        },
        {
          path: 'graduatedClass',
          name: 'graduatedClass',
          component: Framework,
          meta: {
            routerName: 'graduatedClass',
            rootPage: true,
          },
          children: [
            {
              path: 'view/:classId',
              name: 'viewGraduatedClass',
              component: Framework,
              meta: {
                routerName: 'viewGraduatedClass',
                showBack: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: 'staffMgmt',
      name: 'staffMgmt',
      component: Framework,
      meta: {
        routerName: 'staffMgmt',
        noChild: true,
        rootPage: true,
        menu: true,
      },
      children: [
        {
          path: 'view/:memberId',
          name: 'viewStaff',
          component: Framework,
          meta: {
            routerName: 'viewStaff',
            showBack: true,
          },
        },
      ],
    },
    {
      path: 'studentMgmt',
      name: 'studentMgmt',
      component: Framework,
      redirect: {
        name: 'student',
      },
      meta: {
        routerName: 'studentMgmt',
        menu: true,
      },
      children: [
        {
          path: 'student',
          name: 'student',
          component: Framework,
          meta: {
            routerName: 'student',
            rootPage: true,
          },
          children: [
            {
              path: 'view/:studentId',
              name: 'viewStudent',
              component: Framework,
              meta: {
                routerName: 'viewStudent',
                showBack: true,
              },
            },
            {
              path: 'create',
              name: 'createStudent',
              component: Framework,
              meta: {
                routerName: 'createStudent',
                showBack: true,
              },
            },
            {
              path: 'edit/:studentId',
              name: 'editStudent',
              component: Framework,
              meta: {
                routerName: 'editStudent',
                showBack: true,
              },
            },
          ],
        },
        {
          path: 'graduate',
          name: 'graduate',
          component: Framework,
          meta: {
            routerName: 'graduate',
            rootPage: true,
          },
          children: [
            {
              path: 'view/:studentId',
              name: 'viewGraduate',
              component: Framework,
              meta: {
                routerName: 'viewGraduate',
                showBack: true,
              },
            },
          ],
        },
        {
          path: 'quit',
          name: 'quit',
          component: Framework,
          meta: {
            routerName: 'quit',
            rootPage: true,
          },
          children: [
            {
              path: 'view/:studentId',
              name: 'viewQuit',
              component: Framework,
              meta: {
                routerName: 'viewQuit',
                showBack: true,
              },
            },
          ],
        },
      ],
    },
  ],
}

export const teacherStudent = {
  path: 'student',
  name: 'teacherStudent',
  component: Framework,
  meta: {
    routerName: 'teacherStudent',
    auth: ['1405'],
    // noChild: true,
    // rootPage: true,
    menu: true,
  },
  redirect: {
    name: 'current',
  },
  children: [
    {
      path: 'current',
      name: 'current',
      component: Framework,
      meta: {
        routerName: 'current',
        rootPage: true,
      },
      children: [
        {
          path: 'view/:studentId',
          name: 'viewCurrent',
          component: Framework,
          meta: {
            routerName: 'viewCurrent',
            showBack: true,
          },
        },
      ],
    },
    {
      path: 'history',
      name: 'history',
      component: Framework,
      meta: {
        routerName: 'history',
        rootPage: true,
      },
      children: [
        {
          path: 'view/:studentId',
          name: 'viewHistory',
          component: Framework,
          meta: {
            routerName: 'viewHistory',
            showBack: true,
          },
        },
      ],
    },
  ],

  // children: [
  //   {
  //     path: 'view/:studentId',
  //     name: 'teacherViewStudent',
  //     component: Framework,
  //     meta: {
  //       routerName: 'viewStudent',
  //     },
  //   },
  //   {
  //     path: 'edit/:studentId',
  //     name: 'teacherEditStudent',
  //     component: Framework,
  //     meta: {
  //       routerName: 'editStudent',
  //       showBack: true,
  //     },
  //   },
  // ],
}

export const setting = {
  path: 'setting',
  name: 'setting',
  component: Framework,
  redirect: {
    name: 'semester',
  },
  meta: {
    routerName: 'setting',
    auth: ['1401', '1402', '1403', '1404'],
  },
  children: [
    {
      path: 'semester',
      name: 'semesterSetting',
      component: Framework,
      meta: {
        routerName: 'semesterSetting',
        rootPage: true,
        menu: true,
      },
    },
    {
      path: 'section',
      name: 'sectionSetting',
      component: Framework,
      meta: {
        routerName: 'sectionSetting',
        rootPage: true,
        menu: true,
      },
    },
  ],
}

const assessmentSetting = {
  path: 'assessment',
  name: 'assessmentSetting',
  component: Framework,
  meta: {
    routerName: 'assessmentSetting',
    rootPage: true,
    menu: true,
  },
  children: [
    {
      path: 'assessmentSheetDetail/:gradeTableId',
      name: 'assessmentSheetDetail',
      component: Framework,
      meta: {
        routerName: 'assessmentSheetDetail',
        showBack: true,
      },
    },
  ],
}

const typeSetting = {
  path: 'type',
  name: 'typeSetting',
  component: Framework,
  meta: {
    routerName: 'typeSetting',
    rootPage: true,
    menu: true,
  },
}

export const personal = {
  path: 'personal',
  name: 'personal',
  component: Framework,
  hidden: true,
  meta: {
    routerName: 'personal',
    rootPage: true,
  },
}

export const systemMessage = {
  path: 'systemMessage',
  name: 'systemMessage',
  component: Framework,
  hidden: true,
  meta: {
    routerName: 'systemMessage',
    rootPage: true,
  },
}

export const book = {
  path: '/book/:bookId',
  name: 'book',
  component: Book,
  hidden: true,
  meta: {
    routerName: 'book',
    auth: ['1401', '1402', '1403', '1404'],
    rootPage: true,
  },
}

export const phdCourseBook = {
  path: '/phdCourseBook/:bookId',
  name: 'phdCourseBook',
  component: CourseBook,
  meta: {
    routerName: 'phdCourseBook',
    auth: ['1401', '1402', '1403', '1404'],
    rootPage: true,
  },
}

export const flashCard = {
  path: '/flashCard/:bookId',
  name: 'flashCard',
  component: FlashCard,
  meta: {
    routerName: 'flashCard',
    auth: ['1401', '1402', '1403', '1404'],
    rootPage: true,
  },
}

const notFound = [
  {
    path: '/404',
    name: 'notFound',
    component: NotFound,
  },
  {
    path: '*',
    redirect: '/404',
  },
]

const constantRouter = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes: constantRouter,
}) as any

function calcRoute(auths): void {
  const roleType = getRoleType()
  let routes = [
    {
      path: '/app',
      redirect:
        roleType !== '1405' ? '/app/home' : auths.moment ? '/app/moment' : '/app/teacherStudent',
      name: 'layout',
      component: Layout,
      children: [
        {
          ...home,
        },
      ],
    },
    {
      ...book,
    },
    {
      ...phdCourseBook,
    },
    {
      ...flashCard,
    },
    ...notFound,
  ] as any
  const newAssessment = {
    ...assessment,
    children: [
      auths.assessmentSheet && assessmentSheet,
      auths.assessmentReport && assessmentReport,
    ].filter(route => route),
  }
  const newApplication = {
    ...application,
    children: [
      auths.attendance && attendance,
      auths.dailyCare && dailyCare,
      auths.sketch && sketch,
      auths.recipe && recipe,
      auths.diary && diary,
      auths.album && album,
      auths.calendar && calendar,
      auths.leaveAudit && takeLeave,
      auths.mibp && mibp,
      auths.journal && learningJournal,
      auths.phdCourse && phdCourse,
    ].filter(route => route),
  }
  const newSetting = {
    ...setting,
    children: [
      ...setting.children,
      auths.assessmentSheet && assessmentSetting,
      auths.moment && typeSetting,
    ].filter(route => route),
  }
  routes[0].children = [
    ...routes[0].children,
    auths.moment && moment,
    auths.assessment && newAssessment,
    auths.application && newApplication,
    manage,
    teacherStudent,
    auths.notification && message,
    newSetting,
    personal,
    systemMessage,
  ].filter(route => route)
  router.addRoutes(routes)
  Store.commit('setRoutes', routes)
}

function syncRoute(auth): void {
  let auths = {} as any
  if (auth && Object.values(auth).length) {
    auths = auth
    calcRoute(auths)
  } else {
    const schoolId = getSchoolInfo().schoolId
    FeatureController.getSchoolActiveFeatures(schoolId)
      .then(res => {
        let data = {} as any
        res.data.forEach(item => {
          switch (item.featureCode) {
            case 'GROTHMNT':
              data.moment = true
              break
            case 'COMMENT':
              data.comment = true
              break
            case 'ASSSHEET':
              data.assessmentSheet = true
              break
            case 'ASSREPOT':
              data.assessmentReport = true
              break
            case 'ATNDANCE':
              data.attendance = true
              break
            case 'RECORD':
              data.dailyCare = true
              break
            case 'PALETTE':
              data.sketch = true
              break
            case 'RECIPE':
              data.recipe = true
              break
            case 'ALBUM':
              data.album = true
              break
            case 'DIARY':
              data.diary = true
              break
            case 'CALENDER':
              data.calendar = true
              break
            case 'MULTIIBP':
              data.mibp = true
              break
            case 'LEAVE':
              data.leaveAudit = true
              break
            case 'LEARNJOUR':
              data.journal = true
              break
            case 'PHDCOURSE':
              data.phdCourse = true
              break
            case 'NOTIFICA':
              data.notification = true
              break
          }
        })
        const auths = {
          ...data,
          assessment: data.assessmentSheet || data.assessmentReport,
          application:
            data.attendance ||
            data.dailyCare ||
            data.sketch ||
            data.recipe ||
            data.album ||
            data.diary ||
            data.calendar ||
            data.mibp ||
            data.leaveAudit,
          notification: data.notification,
        }
        Store.commit('setAuths', auths)
        calcRoute(auths)
      })
      .catch(err => {
        console.error(err)
      })
  }
}

router.beforeEach(async (to, from, next) => {
  Store.commit('changeForceBack', false)
  const token = getToken()
  if (to.path === '/') {
    next('/app')
  }
  if (to.query.sso) {
    ssoUtils.fromSSOLogic(to, from, next, to.query.sso, token)
  } else if (to.query.access_token && !token) {
    LoginController.switchToken(to.query.access_token)
      .then(res => {
        const token = res.data.token
        const schools = res.data.schools
        setToken(token, false)
        setSchoolInfo(schools[0])
        Store.commit('setRoleType', res.data.roleType)
        setRoleType(res.data.roleType)
        const roleType = res.data.roleType
        router.$addRoutes()
      })
      .catch(err => {
        console.error(err)
      })
  } else {
    if (to.name === 'login') {
      if (token) {
        const roleType = getRoleType()
        if (roleType === '1405') {
          const auths = Store.state.auths
          next(auths.moment ? { name: 'moment' } : { name: 'teacherStudent' })
        } else {
          next({ name: 'home' })
        }
      } else {
        const schoolInfo = getSchoolInfo()
        if (token && schoolInfo && schoolInfo.schoolId) {
          next('/app')
        } else {
          removeToken()
          removeSchoolInfo()
          next()
        }
      }
    } else {
      if (token) {
        if (to.name === 'home') {
          const roleType = getRoleType()
          if (roleType === '1405') {
            const auths = Store.state.auths
            next(auths.moment ? { name: 'moment' } : { name: 'teacherStudent' })
          }
        }
        next()
      } else {
        next({ name: 'login' })
      }
    }
  }
})

router.$addRoutes = () => {
  const newRouter = new VueRouter({
    routes: constantRouter,
  }) as any
  router.matcher = newRouter.matcher
  const auths = Store.state.auths
  syncRoute(auths)
}

router.onReady(() => {
  const schoolInfo = getSchoolInfo()
  if (schoolInfo) {
    if (getToken() && schoolInfo.schoolId) {
      const auths = Store.state.auths
      syncRoute(auths)
    }
  } else {
    if (getToken()) {
      SchoolController.querySchoolBriefList()
        .then(res => {
          const selectedSchool = res.data[0]
          setSchoolInfo(selectedSchool)
          const auths = Store.state.auths
          syncRoute(auths)
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
})

export default router
